// TYPES
import type { ITEUserWithTEIdPAuthSettings } from '@timeedit/types/lib/types';
import { Authentication } from './sections/Authentication';
// COMPONENTS
import { General } from './sections/General';
import UserProfile from './sections/UserProfile';

export interface UserDetailProps {
  user: ITEUserWithTEIdPAuthSettings;
  onChange: (key: string, value: any) => void;
  removeAuthSettingsFromUser: () => void;
}

const UserDetail = ({
  user,
  onChange,
  removeAuthSettingsFromUser,
}: UserDetailProps) => {
  return (
    <>
      <General user={user} onChange={onChange} />
      <Authentication
        user={user}
        onChange={onChange}
        onRemoveAuthSettings={removeAuthSettingsFromUser}
      />
      {user && <UserProfile user={user} onChange={onChange} />}
    </>
  );
};

export default UserDetail;
